<template>
    <div>
        <div class="top pl-4 pr-0">
            <breadcrumb class="bg-light p-0" :items="breadcrumbs" />
            <ClinicHourDetails />
        </div>
    </div>
</template>

<script>
import Breadcrumb from "@/components/commons/breadcrumb.vue";
import ClinicHourDetails from "@/components/setting-clinic-hour-v2/clinic-hour-details.vue";

export default {
    mixins: [],
    components: {
        Breadcrumb,
        ClinicHourDetails
    },
    computed: {
        breadcrumbs() {
            let breadcrumbs = [
                {
                    text: "Settings",
                    href: process.env.APPS + "business/business"
                },
                {
                    text: "Clinic Hours"
                }
            ];
            return breadcrumbs;
        }
    },
    data() {
        return {};
    }
};
</script>
<style scoped>
.top {
    margin-top: 10px;
    margin-bottom: 3px;
}
</style>
